export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    source: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    dispatch(event, eventName, ...rest) {
      if (event && event.preventDefault) event.preventDefault();
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;
      while (parent && (!name || name !== "virtual-list")) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(rest));
      }
    }
  }
};